import React from 'react';
import { BsEye, BsEyeSlash } from 'react-icons/bs';
import './VisibilityIcon.scss';

interface IconProps {
	isHidden?: boolean;
}

const VisibilityIcon = ({ isHidden }: IconProps) => {
	return isHidden ? <BsEyeSlash /> : <BsEye />;
};

export default VisibilityIcon;
